import { TableColumn } from '@ansys-internal/awf-angular/contributions';
import {
  AWCTableCell,
  TableCellAlign,
  TableCellTypes,
} from '@ansys-internal/awc-angular/tables';
import { Icons } from '@ansys-internal/awc-angular/icons';
import { DriveCycleTableType } from '../../../shared/types/drive-cycle-table.type';
import { AWFTableColumn } from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../contributions.enum';

@AWFTableColumn({
  id: ContributionsEnum.DRIVE_CYCLE_TABLE_SELECTED_COLUMN,
  priority: 20,
})
export class DriveCycleTableSelectedColumn implements TableColumn {
  public id: string = ContributionsEnum.DRIVE_CYCLE_TABLE_SELECTED_COLUMN;
  public priority: number = 20;
  public header: string = '';
  public type: TableCellTypes = TableCellTypes.ICON;
  public align: TableCellAlign = TableCellAlign.CENTER;
  public width: number = 50;

  public async render(data: DriveCycleTableType): Promise<AWCTableCell> {
    const [icon, external] = data.selected ? [Icons.CHECK, false] : ['', false];
    return Promise.resolve({
      value: icon,
      externalSrc: external,
    });
  }
}
